<template>
  <div>
    <a
      v-if="url"
      class="call-to-action-button btn"
      :class="reverseColors ? reverseColorCssClass : mainColorCssClass"
      :href="url"
      :target="openURLInNewTab ? '_blank' : '_self'"
    >
      {{ title }}
      <span
        v-if="reverseColors"
        :class="
          'png-icon png-icon-' +
            (iconName ? iconName : reverseColorDefaultIconName)
        "
      ></span>
      <span
        v-else
        :class="
          'png-icon png-icon-' +
            (iconName ? iconName : mainColorDefaultIconName)
        "
      ></span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      default: null
    },
    reverseColors: {
      type: Boolean,
      default: false
    },
    title: {
      required: true,
      type: String
    },
    openURLInNewTab: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mainColorCssClass: "btn-primary",
      mainColorDefaultIconName: "icons-glyph--ko-arrow-next",
      reverseColorCssClass: "btn-white border-dark",
      reverseColorDefaultIconName: "icons-glyph--k-arrow-next"
    };
  }
};
</script>
